import React, { useEffect, useState } from "react";
import {
  FaPhone,
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaStar,
} from "react-icons/fa";

const Topslider = () => {
  const [isMobile, setIsMobile] = useState(false);

  // Function to check screen size
  const checkScreenSize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    // Check screen size on load
    checkScreenSize();
    // Add resize event listener
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize); // Cleanup
  }, []);

  if (isMobile) {
    return null; // Hide component on mobile
  }

  return (
    <div style={{ backgroundColor: "#25bdd8", color: "white", height: "auto" }}>
      <div className="container-fluid py-2">
        <div className="row">
          {/* Left side with phone numbers and email */}
          <div className="col-12 col-md-6 d-flex align-items-center justify-content-center justify-content-md-start mb-2 mb-md-0">
            <FaPhone className="me-2" />
            <span>+91-9657579144</span>

            <FaEnvelope className="mx-2" />
            <span>smartjet96@gmail.com</span>
          </div>

          {/* Right side with social media icons and marquee */}
          <div className="col-12 col-md-6 d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-md-end">
            <div className="d-flex mb-2 mb-md-0">
              <a
                href="https://www.facebook.com/share/z2qbsDwJGPUPrD6C/?mibextid=qi2Omg"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook
                  className="me-3"
                  style={{ color: "white" }}
                  size={30}
                />
              </a>
              <a
                href="https://www.instagram.com/aasmartjet12?utm_source=qr&igsh=MTc1bjV3aXdtNmVwOQ=="
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram
                  className="me-3"
                  style={{ color: "white" }}
                  size={30}
                />
              </a>
              <a
                href="https://www.linkedin.com/company/a-a-smart-jet-technology/posts/?feedView=all"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin
                  className="me-3"
                  style={{ color: "white" }}
                  size={30}
                />
              </a>
            </div>

            {/* Marquee */}
            <div
              style={{ backgroundColor: "#25bdd8", color: "white" }}
              className="py-2 w-100"
            >
              <marquee behavior="" direction="left" scrollamount="8">
                <FaStar
                  style={{ color: "yellow", fontSize: "16px" }}
                  className="me-2"
                />{" "}
                <span>
                  "Experience Premium Quality Batch Coding Printers,
                  Consumables, and Precision Spare Parts. What Are You Waiting
                  For?"
                </span>
              </marquee>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topslider;
